import * as Msal from 'msal';
import APIService from '../APIService'
import axios from 'axios';
import config from '../config'
import jwt_decode from "jwt-decode";

export default class AuthService {
    constructor() {
        this.applicationConfig = config.msalConfig;
        this.app = new Msal.UserAgentApplication(config.msalConfig);
    }


    callback(error, response) {
        if (error == null) {
            sessionStorage.setItem('cctoken', response.idToken.rawIdToken);
            const decoded = jwt_decode(response.idToken.rawIdToken)
            sessionStorage.userId = decoded.sid.split('|')[0];
            sessionStorage.userType = decoded.sid.split('|')[1];
            sessionStorage.companyId = decoded.sid.split('|')[2];
            sessionStorage.userFirstName = decoded.given_name;
            sessionStorage.userSurname = decoded.family_name;
            axios({
                url: `${config.api.url}/api/v1/useradmin/profile`,
                method: 'POST',
                headers: {
                    "Authorization": `Bearer ${response.idToken.rawIdToken}`
                }
            })
            location.reload();
        }
    }

    resetPasswordCallBack(error, response) {
        if (error == null) {
            this.login;
        }
    }

    login() {
        this.app.handleRedirectCallback(this.callback);
        return this.app.loginRedirect(config.tokenRequest)
    };

    resetPassword() {
        this.app.handleRedirectCallback(this.resetPasswordCallBack);
        return this.app.loginRedirect({ authority: config.forgotPasswordAuthority })
    }

    logout() {
        this.app.logout()
        sessionStorage.clear();
    };
    getToken() {
        return this.app.acquireTokenSilent(this.applicationConfig.graphScopes).then(
            accessToken => {
                return accessToken;
            },
            error => {
                return this.app
                    .acquireTokenPopup(this.applicationConfig.graphScopes)
                    .then(
                        accessToken => {
                            return accessToken;
                        },
                        err => {
                            console.error(err);
                        }
                    );
            }
        );
    };
}